import { render, staticRenderFns } from "./common-form-dialog.vue?vue&type=template&id=703c0a66&scoped=true"
import script from "./common-form-dialog.vue?vue&type=script&lang=js"
export * from "./common-form-dialog.vue?vue&type=script&lang=js"
import style0 from "./common-form-dialog.vue?vue&type=style&index=0&id=703c0a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c0a66",
  null
  
)

export default component.exports